import React, { useEffect } from "react";

import ClientStats from "shared/util/ClientStats";
import _str from "shared/util/_str";
import Strf from "shared/components/Strf";
import Link from "shared/components/Link";
import Masthead from "./Masthead";

const Incognito = React.forwardRef((_, ref) => {
	useEffect(() => { ClientStats.update("desktop - incognito - masthead - views"); }, []);

	return (
		<Masthead ref={ref} id="incognito_masthead" className="incognito-masthead" noClose>
			<div className="text">
				<p>
					<Strf vars={{ incognitoMode: <strong>{_str("Incognito Mode")}</strong> }}>
						With $incognitoMode, you can hand-select who sees you on OkCupid.
						That means total control of your visibility.
					</Strf>
				</p>
			</div>
			<div className="button">
				<Link to="/incognito" className="big flatbutton incognito-masthead-learnmore">
					{_str("Learn more")}
				</Link>
			</div>
		</Masthead>
	);
});

export default Incognito;



// WEBPACK FOOTER //
// ./src/routers/Desktop/HeaderBanner/Incognito.jsx